import React from 'react';
import { Link } from 'react-router-dom';
import * as settings from 'Settings';

import styles from './PlaygroundHeader.scss';
import PlaygroundTitle from './playground-header.svg';

// Characters
const characterSlugs = [
  'helipopper',
  'rockin-rabbit',
  'simon-sees',
  'shape-invasion',
  'apple-catch',
  'vine-time',
  'treasure-dive',
  'star-climber',
  'double-hooked',
  'turtle-wax',
  'frost-bite',
  'when-pigs-fly',
  'croc-cannon',
  'burned-out',
  'fly-trap',
  'desert-dive',
  'color-creature',
  'swing-fling',
  'log-run',
  'digging-for-worms',
  'buried-memories',
  'pickle-pop',
];

const PlaygroundHeader = ({ adCampaign, onAdClick }) => {
  const adClass = adCampaign ? ' has-active-ad' : '';
  return (
    <div className={`PlaygroundHeader${adClass}`}>
      <PlaygroundTitle className="PlaygroundHeader__title" />
      <div className="PlaygroundHeader__characters">
        {adCampaign && adCampaign.customCharacter ? (
          <a
            href={adCampaign.customCharacterLink}
            onClick={onAdClick}
            className={`PlaygroundCharacter PlaygroundCharacter--custom PlaygroundCharacter--${adCampaign.id}`}
            target="_blank"
          >
            <img
              src={`${settings.ASSETS_URL}/img/sponsors/playground/character/${adCampaign.customCharacter}`}
              alt=""
            />
          </a>
        ) : null}
        {characterSlugs.map(slug => {
          const imageURI = `${settings.ASSETS_URL}/img/characters/${slug}.svg`;
          return (
            <Link
              key={`character-${slug}`}
              to={`/games/${slug}`}
              className={`PlaygroundCharacter PlaygroundCharacter--${slug}`}
            >
              <img src={imageURI} alt={slug} />
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default PlaygroundHeader;
